import React from "react";
import style from "./sass/backend.scss"
import {

  HashRouter,
  Route,
  Link,
  Switch,

} from 'react-router-dom'
import ReactDOM from "react-dom";
import Listing from "./listing"
import Details from "./details"
import ProductListing from "./product_listing"
import ProductDetail from "./product_detail"
import ProductSettings from "./settings"
import SideBar from "./components/SideBar"

const Index = (props) => {

    return (<HashRouter  >
        <div className="awdp_content">
            <div className="awdp_content_left">
                <div className="awdp_actions clearfix">
                    <h1>Pricing Rules</h1>
                    <div className="awdp_nav_box">
                        <Link className="awdp_add_button" to={'/rule/add'}>Add New Rule</Link>
                        <Link className="awdp_back_button" to={'/'}>Back</Link>
                    </div>
                </div>
                <Switch>
                    <Route path="/"  exact  component={Listing}/>
                    <Route path="/rule/:id" component={Details}/>
                </Switch>
            </div>
            {}
            <SideBar />
        </div>
    </HashRouter >)
    
  };

const ProLists = (props) => {

return (<HashRouter  >
    <div className="awdp_content">
        <div className="awdp_content_left">
            <div className="awdp_actions clearfix">
                <h1>Product Lists</h1>
                <div className="awdp_nav_box">
                    <Link className="awdp_add_button" to={'/list/add'}>Add New List</Link>
                    <Link className="awdp_back_button" to={'/'}>Back</Link>
                </div>
            </div>
            <Switch>
                <Route path="/"  exact  component={ProductListing}/>
                <Route path="/list/:id" component={ProductDetail}/>
            </Switch>
        </div>
        {}
        <SideBar />
    </div>
</HashRouter >)

};

// const ProSettings = (props) => {

//     return (<HashRouter  >
//         <div className="awdp_content">
//             <div className="awdp_content_left">
//                 <div className="awdp_actions clearfix">
//                     <h1>Product Settings</h1>
//                 </div>
//                 <Switch>
//                     <Route path="/"  exact  component={ProductSettings}/>
//                 </Switch>
//             </div>
//             {}
//             <SideBar />
//         </div>
//     </HashRouter >)
    
//     };

if(document.getElementById("awdp_ui_root")){
    ReactDOM.render(<Index wpObject={window.awdp_object }/>, document.getElementById("awdp_ui_root"));
}
if(document.getElementById("awdp_ui_lists")){
    ReactDOM.render(<ProLists wpObject={window.awdp_object }/>, document.getElementById("awdp_ui_lists"));
}
// if(document.getElementById("awdp_ui_settings")){
//     ReactDOM.render(<ProSettings wpObject={window.awdp_object }/>, document.getElementById("awdp_ui_settings"));
// }